import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  GeographyArrayModel,
  GeographyModel,
} from "../../models/GeographyModel";

const initialGeographyState: GeographyArrayModel = {
  all_Geographies: [],
  particular_Geography: {
    geographyId: 0,
    name: "",
    description: "",
    isActive: false,
  },
  isGeographiesFetching: false,
};
const GeographySlice = createSlice({
  name: "ProjectGeography",
  initialState: initialGeographyState,
  reducers: {
    setGeographies(state, action: PayloadAction<GeographyModel[]>) {
      state.all_Geographies = action.payload;
    },
    setParticularGeography(state, action: PayloadAction<GeographyModel>) {
      state.particular_Geography = action.payload;
    },
    setIsGeographiesFetching(state, action: PayloadAction<boolean>) {
      state.isGeographiesFetching = action.payload;
    },
  },
});
export default GeographySlice;
